import { Indicator } from "../../../interfaces/ODSPriorityGroups";

export const buildIndicatorUrl = (
    indicator: Indicator,
    odsSelected: { id: number; name: string },
    module: string,
    period: string,
    isGroups: string,
) => {
    if (!indicator || !period) return "#";

    console.log(odsSelected)
    const isGroupsModule = module === isGroups;
    const odsIdKey = isGroupsModule ? "priorityGroups" : "odsID";

    const params = new URLSearchParams({
        right: indicator.derecho?.titulo ?? "",
        rightId: String(indicator.derecho?.id ?? ""),
        type: indicator.tipoIndicador?.titulo ?? "",
        dimensionID: String(indicator.dimension?.id) ?? "",
        subdimensionID: String(indicator.subdimension?.id) ?? "",
        indicatorID: String(indicator.id),
        [odsIdKey]: String(odsSelected.id),
        period: period,
        page: "1",
        limit: "5",
        //para que se marquen los selects del visualizador
        filterApplied: "true"
    });

    return `/monitor/visualizador-de-indicadores?${params.toString()}`;
};

export const onClickLinkUI = (
    indicator: Indicator,
    odsSelected: { id: number; name: string },
    module: string,
    period: string,
    isGroups: string,
    page: number
) => {

    const isGroupsModule = module === isGroups;
    const label = isGroupsModule ? 'Grupos Prioritarios' : 'ODS';
    const path = isGroupsModule ? '/grupos-prioritarios' : '/ods'

    const previousData = {
        path: `${path}/${String(odsSelected.id)}`,
        period: period,
        label: `Volver a ${label} `,
        scrollTargetId: `${isGroupsModule ? '' : 'tables-ods-priority_group'}`,
        page: page,
        ...(isGroupsModule && { typeIndicator: indicator.tipoIndicador?.titulo ?? "" })
    };

    sessionStorage.setItem("previous", JSON.stringify(previousData));
};